export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    tag: '2',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Estadistica',
        route: 'dashboard-estadistica',
      },
      {
        title: 'Analítica',
        route: 'dashboard-analytics',
      },
    ],
  },
]
